

import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllLeaveledgerReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/leaveledger/all`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all leave leadger Report');
        }
    }
);